export const environment = {
  production: true,
  api: 'https://uat.prr-api.logistics.rtp-eservice.com',
  appVersion: "prr",
  USERDATA_KEY: "6f55a499fcf5",
  authApi: 'https://uat.sso-api.logistics.rtp-eservice.com',
};

export const apiPath = {
  masterSpecicalBranchEquipment: environment.api + '/api/MasterSpecialBranchEquipment',
  masterEvidenceCenterEquipment: environment.api + '/api/MasterEvidenceCenterEquipment',
  masterHospitalEquipment: environment.api + '/api/MasterHospitalEquipment',
  masterBorderPatrolPoliceEquipment: environment.api + '/api/MasterBorderPatrolPoliceEquipment',
  masterTacticalEquipment: environment.api + '/api/MasterTacticalEquipment',
  masterImmigrationEquipment: environment.api + '/api/MasterImmigrationEquipment',
  manageOfficeBuilding: environment.api + '/api/ManageOffice',
  manageResidenceBuilding: environment.api + '/api/ManageResidence',
  manageHospitalBuilding: environment.api + '/api/ManageBuildingHospital',
  master: environment.api + '/api/master',
  manage: environment.api + '/api/manage',
  masterMeeting: environment.api + '/api/MasterMeetingEquipment',
  masterRequestEquipment: environment.api + '/api/MasterRequestEquipment',
  masterEquipment: environment.api + '/api/MasterEquipment',
  requestEquipment: environment.api + '/api/RequestEquipment',
  dashboard: environment.api + '/api/Dashboard',
  ctlMasterEquipmentCategory: environment.api + '/api/CtlMasterEquipmentCategory',
  ctlMasterEquipment: environment.api + '/api/CtlMasterEquipment',
  mstEquipmentQuota: environment.api + '/api/MstEquipmentQuota',
  mstManageEquipmentQuota: environment.api + '/api/MstManageEquipmentQuota',
  ctlStandardType: environment.api + '/api/CtlStandardType',
  ctlMasterEquipmentGroup: environment.api + '/api/CtlMasterEquipmentGroup',
  mstManageEquipmentOther: environment.api + '/api/MstManageEquipmentOther',
  manageCount: environment.api + '/api/ManageCount',
  dataVerification: environment.api + '/api/DataVerification',
  ctlMasterOrganize: environment.api + '/api/CtlMasterOrganize',
  ctlMasterJob: environment.api + '/api/CtlMasterJob',
};
